import { useRecoilState } from "recoil";
import { notificationFilterState } from "./atoms/notification";
import { getNotificationsList, makeNotificationsRead, makeNotificationsReadAll } from "../app/services/base/notifications/notifications.service";

export const useUpdatesAndNotifications = () => {
	const [notificationList, setNotificationList] = useRecoilState(notificationFilterState);

	const list = () => {
		getNotificationsList({origin: 1}).then((resp) => {
			setNotificationList(resp)
		})
	}

	const markReadNotification = (id: number) => {
		makeNotificationsRead(id).then((resp) => {
			let notifications = notificationList.filter((obj) => obj.id !== id);
			setNotificationList(notifications)
		})
	}

	const markAllReadNotification = () => {
		makeNotificationsReadAll({origin: 1}).then((resp) => {
			setNotificationList([])
		})
	}

	return {notificationList, list, markReadNotification, markAllReadNotification }
};
